import { IntlShape } from 'react-intl';

import { getTextWithSoftHyphens, UnmappedFacetValue } from '@app/components';
import { sharedMessages } from '@app/translations';

export const getStatusLabel = ($t: IntlShape['$t'], value: string) => {
  const labelMap = {
    Available: $t(sharedMessages.available),
    'Not Available': $t(sharedMessages.notAvailable),
  };

  return labelMap[value] ?? value;
};

export const getStatusOptions = (
  $t: IntlShape['$t'],
  statusValues: UnmappedFacetValue[] = []
) =>
  statusValues.map(({ id, totalRecords }) => ({
    label: getTextWithSoftHyphens(getStatusLabel($t, id)),
    value: id,
    count: totalRecords,
    id,
  }));
